import axios from "./axiosInstance";

const VerifyOtpAPI = {
  postOtpVerify: (params) => axios.post(`/otp_verify`, params),
};

export default VerifyOtpAPI;
